<template>
  <div>
    <div class="terminate-record-table-title">解约(买断/退出)申请记录</div>
    <div class="terminate-record-table">
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="cancelType" label="解约类型" width="120">
          <template slot-scope="scope">
            {{
              scope.row.cancelType === "BUY_OUT"
                ? "解约（买断）"
                : scope.row.cancelType === "REFUND"
                  ? "解约（退出）"
                  : scope.row.cancelType === "DEFAULT"
                    ? "违约"
                    : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="cancelNo" label="解约订单编号" width="200" />
        <el-table-column prop="cancelRequestTime" label="解约申请时间" width="180" />
        <el-table-column prop="refundFinishTime" label="解约完成时间" width="180" />
        <el-table-column prop="cancelReason" label="解约原因" width="160" />
        <el-table-column prop="cancelAmount" label="解约应付金额（元）" width="150" />
        <el-table-column prop="refundAmount" label="解约应退金额（元）" width="150" />
        <el-table-column prop="refundByName" label="解约退款操作人" width="140" />
        <el-table-column prop="refundOperateTime" label="解约退款操作时间" width="180" />
        <!-- <el-table-column prop="refundFinishTime" label="解约退款完成时间" width="180" /> -->
      </el-table>
      <!-- 分页组件 -->
      <div class="pagination-container" v-if="pagination.total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TerminateRecordTable",
  props: {
    activityorderNo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  watch: {
    activityorderNo: {
      handler(newVal) {
        if (newVal) {
          this.fetchData();
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchData() {
      if (!this.activityorderNo) {
        console.log('解约申请记录：缺少activityOrderNo参数');
        return;
      }

      const params = {
        activityOrderNo: this.activityorderNo,
        pageNum: this.pagination.current, 
        pageSize: this.pagination.pageSize
      };
      params.corpNo = this.$store?.state?.corpNo;
      console.log('解约申请记录请求参数:', params);
      this.$H.post(this, this.$A.zeropay.cancelOrderRecordPage, params)
        .then(res => {
          if (res.data && res.data.status === 200) {
            const responseData = res.data.data || [];
            if (Array.isArray(responseData)) {
              this.tableData = responseData;
              this.pagination.total = responseData.length;
            } else {
              this.tableData = responseData.content || [];
              this.pagination.total = responseData.totalElements || 0;
            }
          } else {
            this.tableData = [];
            this.pagination.total = 0;
            this.$message.error(res.data?.msg || '获取解约申请记录失败');
          }
        })
        .catch(err => {
          console.error('获取解约申请记录失败:', err);
          this.tableData = [];
          this.pagination.total = 0;
          this.$message.error('获取解约申请记录失败');
        });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.terminate-record-table-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.terminate-record-table {
  margin-top: 10px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>